import gql from "graphql-tag";

export default gql`
  fragment RankedIssuerFields on RankedIssuer {
    overallRankingPlacement {
      periodStartDate
      periodEndDate
      position
    }
    overallRankingRatingSummary {
      periodStartDate
      periodEndDate
      overallRating
      totalRatings
      distribution {
        rating
        totalRatings
        percentOfTotal
      }
    }
    rating {
      _id
      value
      ratedAt
    }
  }
`;
